module.exports = __webpack_public_path__ + "static/media/doggo.a6eaaf88.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/doggo.png
// module id = 373
// module chunks = 0